import { render, staticRenderFns } from "./azyzhfls.vue?vue&type=template&id=ff8bf830&"
import script from "./azyzhfls.vue?vue&type=script&lang=js&"
export * from "./azyzhfls.vue?vue&type=script&lang=js&"
import style0 from "./azyzhfls.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports